import { client } from '@/client';
import {
  SuppressedDomain,
  SuppressedDomainsResponse,
  UpdateSuppressedDomainsRequest,
} from '@/client/campaigns/types/suppressed-domains.type';
import { GenericForbiddenApiError } from '@/hooks/query';
import {
  useMutation,
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';

const queryKey = 'suppressed-domains';

export const useSuppressedDomains = (
  params?: UseQueryOptions,
): UseQueryResult<SuppressedDomainsResponse> & {
  suppressedDomains: SuppressedDomainsResponse | undefined;
} => {
  const {
    retry = false,
    retryDelay = 500,
    staleTime = 0,
    cacheTime = 0,
    ...restOptions
  } = params || {};

  const { data, ...rest } = useQuery(
    [queryKey],
    () => client.suppressedDomains.getSuppressedDomains(),
    {
      retry,
      retryDelay,
      staleTime,
      cacheTime,
      ...(restOptions as any),
    },
  );

  return {
    suppressedDomains: data,
    ...(rest as UseQueryResult<SuppressedDomainsResponse>),
  };
};

export const useUpdateSuppressedDomainsList = (): {
  update: (
    payload: UpdateSuppressedDomainsRequest,
  ) => Promise<SuppressedDomain>;
} & {
  isLoading: boolean;
  error: GenericForbiddenApiError | null;
} => {
  const { mutateAsync, ...rest } = useMutation<
    SuppressedDomain,
    GenericForbiddenApiError,
    UpdateSuppressedDomainsRequest
  >('updateSuppressedDomainsList', (payload: UpdateSuppressedDomainsRequest) =>
    client.suppressedDomains.updateSuppressedDomainsList(payload),
  );

  return { update: mutateAsync, ...(rest as any) };
};
